/**
 * イベント参加ギフト
 * カートでクーポンコードを入力すると、ギフト商品を自動でカートに入れて割引を適用する。
 * 無料化の判定は Shopify の Buy X Get Y 割引（サーバー側）が行い、この JS は
 * 「カートに入れる操作の代行」と「整合性の維持」だけを担当する。
 */
(function () {
  var CFG = window.EVENT_GIFT;
  if (!CFG || !CFG.enabled || !CFG.giftVariantId) return;

  CFG.codes = (CFG.codes || [])
    .map(function (c) { return String(c || '').trim().toLowerCase(); })
    .filter(Boolean);
  if (!CFG.codes.length) return;

  var routes = (window.theme && window.theme.routes) || {};
  var CART_URL = routes.cart_url || '/cart';
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var UPDATE_URL = routes.cart_update_url || '/cart/update';

  // 既存の cart-discounts.js と同じ再描画対象
  var SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  var busy = false;
  var debounceTimer;

  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  function isOurCode(c) { return CFG.codes.indexOf(norm(c)) !== -1; }

  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function withSections(body) {
    body.sections = SECTIONS.map(function (s) { return s.section; });
    body.sections_url = window.location.pathname;
    return body;
  }

  function render(state) {
    if (state && state.sections) {
      SECTIONS.forEach(function (s) {
        var host = document.getElementById(s.id);
        if (!host) return;
        var target = host.querySelector(s.selector) || host;
        var html = state.sections[s.section];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
        if (parsed) target.innerHTML = parsed.innerHTML;
      });
    }
    decorate();
    return state;
  }

  function giftLine(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === CFG.giftVariantId) return items[i];
    }
    return null;
  }

  function hasRequired(cart) {
    return ((cart && cart.items) || []).some(function (i) {
      return i.variant_id !== CFG.giftVariantId &&
        CFG.requiredProductIds.indexOf(i.product_id) !== -1 &&
        i.quantity > 0;
    });
  }

  function codeOnCart(cart) {
    return ((cart && cart.discount_codes) || []).some(function (d) { return isOurCode(d.code); });
  }

  function showError(message) {
    document.querySelectorAll('cart-discounts .cart-discounts--error').forEach(function (box) {
      var text = box.querySelector('.cart-discounts--error-text');
      if (text) text.textContent = message;
      box.classList.add('event-gift-error');
      box.removeAttribute('hidden');
    });
  }

  function clearError() {
    document.querySelectorAll('cart-discounts .cart-discounts--error.event-gift-error').forEach(function (box) {
      box.setAttribute('hidden', '');
      box.classList.remove('event-gift-error');
    });
  }

  /** ギフト行にバッジを付け、数量変更と削除を封じる */
  function decorate() {
    var selector = '[data-id^="' + CFG.giftVariantId + ':"],[data-product-id^="' + CFG.giftVariantId + ':"]';
    document.querySelectorAll(selector).forEach(function (node) {
      var line = node.closest('tr') || node.closest('.product-cart-item');
      if (!line || line.dataset.eventGift === '1') return;
      line.dataset.eventGift = '1';
      line.classList.add('event-gift-line');
      line.querySelectorAll('quantity-selector, .remove').forEach(function (el) {
        el.setAttribute('hidden', '');
      });
      var badge = document.createElement('span');
      badge.className = 'event-gift-badge';
      badge.textContent = CFG.badge || 'ギフト';
      var link = line.querySelector('.cart-product-link');
      if (link && link.parentNode) link.parentNode.insertBefore(badge, link.nextSibling);
      else line.insertBefore(badge, line.firstChild);
    });
  }

  /** カートの状態を正す。水煮やコードが無くなればギフトを外す */
  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var gift = giftLine(cart);
      var eligible = hasRequired(cart) && codeOnCart(cart);

      if (gift && !eligible) {
        return post(CHANGE_URL, withSections({ id: gift.key, quantity: 0 })).then(render);
      }
      if (gift && gift.quantity !== 1) {
        return post(CHANGE_URL, withSections({ id: gift.key, quantity: 1 })).then(render);
      }
      if (!gift && eligible) {
        return post(ADD_URL, { id: CFG.giftVariantId, quantity: 1 })
          .then(function () { return post(UPDATE_URL, withSections({})); })
          .then(render);
      }
      decorate();
    }).catch(function () { /* カートの整合処理は失敗しても購入導線を止めない */ })
      .then(function () { busy = false; });
  }

  /** クーポンコード適用。ギフト投入 → コード適用 → 再描画の順で行う */
  function applyCode(code, button) {
    if (busy) return;
    busy = true;
    if (button) button.classList.add('loading');
    clearError();

    getCart().then(function (cart) {
      if (!hasRequired(cart)) {
        showError(CFG.errorNoRequired);
        return null;
      }
      if (giftLine(cart)) return cart;
      return post(ADD_URL, { id: CFG.giftVariantId, quantity: 1 }).then(getCart);
    }).then(function (cart) {
      if (!cart) return null;
      var codes = ((cart.discount_codes) || [])
        .map(function (d) { return d.code; })
        .filter(function (c) { return c && !isOurCode(c); });
      codes.push(code);
      return post(UPDATE_URL, withSections({ discount: codes.join(',') }));
    }).then(function (state) {
      if (!state) return null;
      render(state);
      var applied = ((state.discount_codes) || []).some(function (d) {
        return isOurCode(d.code) && d.applicable !== false;
      });
      if (applied) return null;
      // コードが効かなかったときは有料のギフトを残さない
      showError(CFG.errorNotApplicable);
      return getCart().then(function (cart) {
        var gift = giftLine(cart);
        if (!gift) return null;
        return post(CHANGE_URL, withSections({ id: gift.key, quantity: 0 })).then(render);
      });
    }).catch(function () {
      showError(CFG.errorNotApplicable);
    }).then(function () {
      if (button) button.classList.remove('loading');
      busy = false;
      decorate();
    });
  }

  // 既存の cart-discounts.js より先に捕まえる（キャプチャフェーズ）
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var button = e.target.closest('.cart-discounts--button');
    if (!button) return;
    var root = button.closest('cart-discounts');
    var input = root && root.querySelector('.cart-discounts--input');
    var code = input ? input.value.trim() : '';
    if (!isOurCode(code)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    applyCode(code, button);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var input = e.target.closest('.cart-discounts--input');
    if (!input) return;
    e.preventDefault();
    var root = input.closest('cart-discounts');
    var button = root && root.querySelector('.cart-discounts--button');
    if (button) button.click();
  }, true);

  function start() {
    decorate();
    reconcile();
    var observer = new MutationObserver(function () {
      if (busy) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(reconcile, 350);
    });
    ['Cart', 'Cart-Drawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
